import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ComptaComponent } from './compta/compta.component';
import { FactureEntreeComponent } from './facture-entree/facture-entree.component';
import { FactureSortieComponent } from './facture-sortie/facture-sortie.component';
import { InvoiceTabComponent } from './invoice-tab/invoice-tab.component';
import { PrestationToInvoiceComponent } from './prestation-to-invoice/prestation-to-invoice.component';
import { TimesheetComponent } from './timesheet/timesheet.component';

const routes: Routes = [
	{ path: '',  component: ComptaComponent, children: [
		{ path: '', redirectTo: 'sortie', pathMatch: 'full' },
		{ path: 'entree',  component: FactureEntreeComponent, data: {type: 1} },
		{ path: 'sortie',  component: FactureSortieComponent, data: {type: 2} },
		{ path: 'to-invoice',  component: PrestationToInvoiceComponent },
		{ path: 'view/:id',  component: InvoiceTabComponent }
	]},
  { path: 'timesheet', component: TimesheetComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComptaRoutingModule { }
